import {
	FETCHING_DATA_FROM_API,
	INPUT_SWAP_QUOTE_LOADING,
	LIVE_SEARCH_LOADING,
	BUILDING_COMPONENT,
	SENDING_TRANSACTION,
	UPDATING_DATA,
	BUILDING_APP,
} from "helpers/constants";

export const fetchingDataFromApi = (loadingStatus) => (dispatch) => {
	dispatch({
		type: FETCHING_DATA_FROM_API,
		payload: loadingStatus,
	});
};

export const buildingComponent = (loadingStatus) => (dispatch) => {
	dispatch({
		type: BUILDING_COMPONENT,
		payload: loadingStatus,
	});
};

export const buildingApp = (loadingStatus) => (dispatch) => {
	dispatch({
		type: BUILDING_APP,
		payload: loadingStatus,
	});
};

export const updatingData = (loadingStatus) => (dispatch) => {
	dispatch({
		type: UPDATING_DATA,
		payload: loadingStatus,
	});
};

export const liveSearchLoadingStatus = (loadingStatus) => (dispatch) => {
	dispatch({
		type: LIVE_SEARCH_LOADING,
		payload: loadingStatus,
	});
};

export const sendingTransaction = (loadingStatus) => (dispatch) => {
	dispatch({
		type: SENDING_TRANSACTION,
		payload: loadingStatus,
	});
};

export const inputSwapQuoteLoadingStatus = (loadingStatus) => (dispatch) => {
	dispatch({
		type: INPUT_SWAP_QUOTE_LOADING,
		payload: loadingStatus,
	});
};
